import type { ApiError } from './api-error.enum';

export interface Loadable<T> {
  value?: T;
  loading: boolean;
  loaded: boolean;
  error?: ApiError;
}

export function emptyLoadable<T>(): Loadable<T> {
  return {
    loading: false,
    loaded: false,
  };
}
